<div class="c-testerModal">
  <div class="c-testerModal__container">
    <div class="c-testerModal__content">
      <fieldset>
        <legend>Achievements — Unlock</legend>
        <div class="e-form">
          <div class="e-form__field wrap">
            @for (entry of achievementEntries; track entry[0]; let i = $index) {
              <div class="e-form__element__button__row">
                <slotcom-button
                  class="c-button--pink"
                  [isDisabled]="isAchievementButtonDisabled(entry[1], i)"
                  (click)="unlockAchievement(entry[1])">
                  {{ entry[0] }}
                </slotcom-button>
              </div>
            }
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Achievements — Increment</legend>
        <div class="e-form">
          <div class="e-form__field wrap">
            <div class="e-form__element__row">
              <label>Amount</label>
              <input
                type="number"
                [ngModel]="incrementAmount()"
                (ngModelChange)="incrementAmount.set(+$event)"
                min="1" />
            </div>
            @for (entry of achievementEntries; track entry[0]; let i = $index) {
              <div class="e-form__element__button__row">
                <slotcom-button
                  class="c-button--pink"
                  [isDisabled]="isAchievementButtonDisabled(entry[1], i)"
                  (click)="incrementAchievement(entry[1])">
                  {{ entry[0] }}
                </slotcom-button>
              </div>
            }
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Game Stats</legend>
        <div class="e-form">
          <div class="e-form__field column">
            @for (key of statPayloadKeys; track key) {
              <div class="e-form__element__row">
                <div>
                  <label>{{ key }}</label>
                  <input
                    type="number"
                    [ngModel]="getStatAmount(key)"
                    (ngModelChange)="setStatAmount(key, +$event)"
                    min="1" />
                </div>
                <div class="e-form__element__button__row">
                  <slotcom-button
                    class="c-button--pink"
                    (click)="sendGameStat(key)">
                    Send {{ key }}
                  </slotcom-button>
                </div>
              </div>
            }
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</div>
